function compareBuild() {

var compareList = localStorage.getItem('compare');
  var compareArray = JSON.parse(compareList);

for ( var i = 0; i < compareArray.length; i++) {

    console.log(compareArray[i])

fetch('http://test-store-rainy-city.myshopify.com/products/' + compareArray[i] + '?view=compare')
    .then(function(response) {
        return response.text()
    })
    .then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, "text/html");

        // You can now even select part of that html as you would in the regular DOM 
        // Example:
        // var docArticle = doc.querySelector('article').innerHTML;

        console.log(doc);

        $( "#product__card").append( doc.getElementById("product-card-data-cell"));
        $( "#product__price" ).append( doc.getElementById("product-price-data-cell"));
        $( "#product__weight" ).append( doc.getElementById("product-weight-data-cell"));
        $( "#product__quantity" ).append( doc.getElementById("product-stock-data-cell"));
    })
    .catch(function(err) {  
        console.log('Failed to fetch page: ', err);  
    }); } }

compareBuild();